import Stage from "../images/aboutUsPage/stage.png"

const intro = [
    {
        type: "paragraph",
        content: "C3 Construction Robotics is established in July 2023, is a pioneering high-tech enterprise dedicated to advancing intelligent robotics for the construction industry. Our technology is from the CUHK, we combine academic excellence with cutting-edge innovation to deliver transformative solutions that make construction safer, smarter, and more efficient."
    },
    {
        type: "paragraph",
        content: "Our flagship RoBosun-Family system offers a comprehensive suite of automated robots designed for exterior wall maintenance of high-rise buildings. This one-stop solution integrates five specialized product lines—inspection, surfacing, patching, painting, and cleaning—creating a seamless service for building assessment, repair, and upkeep."
    },
    {
        type: "image",
        src: Stage,
        alt: "Stage"
    },
    {
        type: "paragraph",
        content: "Among our commercially deployed technologies are the RoBosun-Tapper (inspection) and RoBosun-Painter robots, with the RoBosun-Cleaner currently in development. At C3, we’re not just building robots—we’re building the future of construction. Our mission is to accelerate industry-wide automation and intelligent transformation, reducing human risk and elevating productivity across every site we serve."
    }
];

export default intro;